import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AccountEditor } from "../../../editor/AccountEditor";
import { _Certificate } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectTypetoCretificate } from "./SelectTypetoCretificate";
import { FileInput } from "../../../theme/Component/FileInput";
import { BasicButton } from "../../../theme/Component/BasicButton";
export const Certificate = () => {

    // const certificate = useDataBean(_Certificate);
    const single = Singleton.getInstance();
    const { instance, lista, setLista, bean, setBean, deleteItemVoid, update } = useDataBean(_Certificate);
    // const [lista, setLista] = useState<any>([]);
    const [idAccount, setIDAccount] = useState<number>(NaN);
    const [type, settype] = useState<number>(NaN);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalcreatecertified, setModalcreatecertified] = useState<any>({ name: 'Agregar Certificado', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [form, setForm] = useState<any>({
        IDAccount: NaN,
        password: null,
        type: null,
        filename: null,
        directory: null,
        dataStore: null,
        Media: NaN,
        MediaContext: NaN,
    })
    useEffect(() => {

    }, [])

    const getLista = () => {

        instance.getCertificateCatalog(idAccount).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }

    const create = () => {
        setBean({

        });
        setModalcreatecertified({ ...modalcreatecertified, "view": true });
    }
    const deleteItem = () => {
        deleteItemVoid(bean.IDCertificate).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {

        update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const saveCertificate = () => {


        instance.saveCertificate(bean.IDAccount, bean.Type, bean.Password, bean.Media, bean.MediaContext, null).then(
            (resp: any) => {
                if (resp) {
                    getLista()
                    // setLista(resp)
                    console.log(resp)
                    setModalcreatecertified({ ...modalcreatecertified, "view": false });
                }
            }
        )

    }

    const head = [
        { title: 'ID', property: 'IDCertificate', visible: true },
        { title: 'Nombre', property: 'AccountName', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Serial', property: 'SerialNumber', visible: true },
        { title: 'Algoritmo', property: 'SignatureAlgorithmName', visible: true },
        { title: 'ID Algoritmo', property: 'SignatureAlgorithmOID', visible: true },
        { title: 'SubjectDN', property: 'SubjectDN', visible: true },
        { title: 'Version', property: 'Version', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: true },
        { title: 'Fecha Inicial', property: 'InitDate', visible: true },
        { title: 'Fecha Final', property: 'UptoDate', visible: true },
    ]
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            // { titulo: 'Crear Certificado Digital', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModalcreatecertified({ ...modalcreatecertified, "name": `crear`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": "Eliminar Software de Facturación Electrónica" }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Certificados Digitales">
            <div className="row">
                <div className="col-md-4">
                    <AccountEditor label="Titular del Certificado" idAccount={idAccount} onChange={(e) => { setIDAccount(e.IDAccount) }} />
                </div>
                {/* <div className="col-md-4">
                    <SelectTypetoCretificate idSelector={type} onChange={(e) => { settype(e) }} />
                </div> */}
                <div className="col-md-4 mt-4">
                    <BasicButton eventClick={getLista} icon="ri-search-line" children={"Buscar"} />
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>

                    <Modal modal={modalcreatecertified} updateModal={setModalcreatecertified} eventModal={saveCertificate}>
                        {/* <Submacroprocces IDMacroProcess={certificate.bean.IDCertificate} /> */}
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <AccountEditor idAccount={bean.IDAccount} label="Titular del Certificado" onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Contraseña</label>
                                    <input type="text" name="Password" className="form-control" value={bean.Password} onChange={(e) => { setBean({ ...bean, "Password": e.target.value }) }} />
                                </div>
                                <div className="col-md-6">
                                    <SelectTypetoCretificate idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} />
                                </div>

                                <div className="col-md-6">
                                    <FileInput
                                        Media={bean.Media}
                                        MediaContext={bean.MediaContext}
                                        directory="requirement"
                                        label="Cargar un archivo"
                                        onCreate={({ MediaContext, Media }: any) => {
                                            setBean({
                                                ...bean,
                                                Media: Media, MediaContext: MediaContext

                                            });
                                        }}
                                    />
                                </div>
                            </div>


                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}